import type z from 'zod/v4'
import { index, integer, pgTable, text, timestamp, uuid } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema, createUpdateSchema } from 'drizzle-zod'

export const Contributor = pgTable(
  'contributor',
  {
    id: uuid().notNull().primaryKey(),
    name: text().notNull(),
    bio: text(),
    avatarUrl: text(),
    legacyAuthorId: integer(),
    legacyNeonAuthorId: uuid(),
    legacyIllustratorId: integer(),
    legacyNeonIllustratorId: uuid(),
    updatedAt: timestamp({ mode: 'date', withTimezone: true, precision: 3 }).notNull(),
    createdAt: timestamp({ mode: 'date', withTimezone: true, precision: 3 }).notNull(),
  },
  (columns) => [
    index('contributor_name_idx').on(columns.name),
    index('contributor_updated_at_idx').on(columns.updatedAt),
    index('contributor_created_at_idx').on(columns.createdAt),
  ],
)

export const InsertContributorSchema = createInsertSchema(Contributor)
export const UpdateContributorSchema = createUpdateSchema(Contributor)
  .omit({
    id: true,
    legacyAuthorId: true,
    legacyNeonAuthorId: true,
    legacyIllustratorId: true,
    legacyNeonIllustratorId: true,
  })
  .partial()
export const SelectContributorSchema = createSelectSchema(Contributor)

export type InsertContributor = typeof Contributor.$inferInsert
export type UpdateContributor = z.infer<typeof UpdateContributorSchema>
export type SelectContributor = typeof Contributor.$inferSelect
